import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "pl-4 py-4"
};
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col flex-1 w-full h-full bg-white"
};
const _hoisted_3 = {
  class: "flex justify-between items-center pl-4 pr-10 pb-6"
};
const _hoisted_4 = {
  class: "flex"
};
const _hoisted_5 = {
  class: "overflow-y-auto flex-1 print:overflow-hidden"
};
const _hoisted_6 = {
  class: "inline-block print:inline py-2 min-w-full align-middle"
};
const _hoisted_7 = {
  class: "py-2 px-52 flex justify-center"
};
const _hoisted_8 = {
  key: 0,
  class: "m-10 py-10 px-52 text-lg text-gray-800"
};
const _hoisted_9 = {
  class: "bar-border-bottom border-gray-200 shadow"
};
const _hoisted_10 = {
  class: "min-w-full divide-y divide-gray-200"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["onClick"];
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  key: 1,
  class: "m-10 py-20 px-52 flex justify-center text-lg text-gray-800"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_loader = _resolveComponent("loader");
  const _component_main_header = _resolveComponent("main-header");
  const _component_LlSecondaryButton = _resolveComponent("LlSecondaryButton");
  const _component_product_notice = _resolveComponent("product-notice");
  const _component_update_custom_field = _resolveComponent("update-custom-field");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$setup.loading ? (_openBlock(), _createBlock(_component_loader, {
    key: 0,
    what: 'Custom Fields',
    class: "mt-32"
  })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_main_header, {
    content: "Field Mapping"
  }), _createElementVNode("div", _hoisted_4, [_createVNode(_component_LlSecondaryButton, {
    type: "button",
    name: "newExpense",
    color: "primary",
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $setup.createCustomField(), ["prevent"]))
  }, {
    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("span", {
      class: "fa fa-plus pr-1"
    }, null, -1), _createTextVNode(" New Custom Field ", -1)]))]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_product_notice, {
    state: $props.state,
    label: 'Custom fields are',
    product: 'customFieldMapping'
  }, null, 8, ["state"]), $setup.customFieldStore.showUpdateCustomFieldModal ? (_openBlock(), _createBlock(_component_update_custom_field, {
    key: 0,
    customField: $setup.customFieldStore.selectedCustomField,
    alerts: $props.alerts,
    onFilter: $setup.getFieldLists
  }, null, 8, ["customField", "alerts", "onFilter"])) : _createCommentVNode("", true)]), $setup.customFieldNotSet ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Field Mapping allows you to tailor your organization to your own unique requirements. This page will allow you to create new fields, map any to QuickBooks Online fields, and select what page within Leanlaw those fields are present on. Click the ' + New Custom Field ' above to create your first field. ")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createElementVNode("table", _hoisted_10, [_cache[4] || (_cache[4] = _createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", {
    class: "sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
  }, " LeanLaw Field "), _createElementVNode("th", {
    class: "sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
  }, " QuickBooks Custom Field "), _createElementVNode("th", {
    class: "sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
  }, " Available On "), _createElementVNode("th", {
    class: "sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
  }, " Type "), _createElementVNode("th", {
    class: "sticky top-0 py-4 px-6 print:px-1 text-xs font-medium tracking-wider text-left text-gray-500 uppercase bg-gray-50"
  }, " Status "), _createElementVNode("th")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.customFieldLists, (customField, idx) => {
    return _openBlock(), _createElementBlock("tr", {
      key: idx
    }, [_createElementVNode("td", {
      class: "py-3 px-6 cursor-pointer",
      onClick: _withModifiers($event => $setup.updateCustomField(customField.id, customField), ["prevent"])
    }, _toDisplayString(customField.name), 9, _hoisted_11), _createElementVNode("td", {
      class: "py-3 px-6 cursor-pointer",
      onClick: _withModifiers($event => $setup.updateCustomField(customField.id, customField), ["prevent"])
    }, [_withDirectives(_createElementVNode("span", null, [...(_cache[2] || (_cache[2] = [_createElementVNode("img", {
      src: "/img/qb16x16.png"
    }, null, -1)]))], 512), [[_vShow, customField.QBOCustomField]]), _createTextVNode(" " + _toDisplayString(customField.QBOCustomField), 1)], 8, _hoisted_12), _createElementVNode("td", {
      class: "py-3 px-6 cursor-pointer",
      onClick: _withModifiers($event => $setup.updateCustomField(customField.id, customField), ["prevent"])
    }, _toDisplayString($setup.availableOn(customField)), 9, _hoisted_13), _createElementVNode("td", {
      class: "py-3 px-6 cursor-pointer",
      onClick: _withModifiers($event => $setup.updateCustomField(customField.id, customField), ["prevent"])
    }, _toDisplayString(customField.type), 9, _hoisted_14), _createElementVNode("td", {
      class: _normalizeClass(["py-3 px-6 cursor-pointer", {
        'text-green-regular': customField.active,
        'text-error': !customField.active
      }]),
      onClick: _withModifiers($event => $setup.updateCustomField(customField.id, customField), ["prevent"])
    }, _toDisplayString(customField.active ? "Enabled" : "Disabled"), 11, _hoisted_15), _createElementVNode("td", {
      class: "no-print py-3 px-6 cursor-pointer",
      onClick: _withModifiers($event => $setup.updateCustomField(customField.id, customField), ["prevent"])
    }, [...(_cache[3] || (_cache[3] = [_createElementVNode("span", {
      class: "fa fa-pencil icon no-print"
    }, null, -1)]))], 8, _hoisted_16)]);
  }), 128))])])]), $setup.customFieldNotSet ? (_openBlock(), _createElementBlock("div", _hoisted_17, [...(_cache[5] || (_cache[5] = [_createElementVNode("h3", null, "Sample of Fields Mapped", -1)]))])) : _createCommentVNode("", true)])])]))]);
}